import { date, number, object } from 'yup';

export type UpdateSubscriptionForm = {
    expiresAt: Date | null;
    freeTowingServices: string;
    freeAmbulanceServices: string;
};

export const updateSubscriptionFormSchema = object().shape({
    expiresAt: date().nullable().required('La fecha de fin es requerida'),
    freeTowingServices: number()
        .transform((value) => {
            if (value === '' || value == null) return undefined;
            return Number(value);
        })
        .integer('Servicios de grúa debe ser un número entero')
        .min(0, 'Servicios de grúa no puede ser negativo')
        .required('Servicios de grúa es requerido'),
    freeAmbulanceServices: number()
        .transform((value) => {
            if (value === '' || value == null) return undefined;
            return Number(value);
        })
        .integer('Servicios de ambulancia debe ser un número entero')
        .min(0, 'Servicios de ambulancia no puede ser negativo')
        .required('Servicios de ambulancia es requerido'),
});
